import DemographicCampaignPanel from './demographicCampaignPanel.container';

export default DemographicCampaignPanel;